import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { PageHeader } from "../components/common/PageHeader";
import { DataTable } from "../components/common/DataTable";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../components/ui/dialog";

export default function ClientReturns() {
  const [refresh, setRefresh] = useState(0);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);
  const [remarks, setRemarks] = useState("");

  const accept = async () => {
    try {
      await api.post("/materials/client-accept", { material_id: active.id, remarks });
      toast.success("Marked Accepted by Client");
      setOpen(false); setRemarks(""); setRefresh((n) => n + 1);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const columns = [
    { key: "material_number", label: "Serial", mono: true, render: (r) => <span className="font-mono text-xs font-medium text-slate-900">{r.material_number}</span> },
    { key: "project_name", label: "Project" },
    { key: "current_status", label: "Status", render: () => <Badge className="bg-red-100 text-red-700">Sent Back to Client</Badge> },
  ];

  return (
    <div>
      <PageHeader title="Client Returns" subtitle="Materials sent back to client — record client acceptance/closure" />
      <DataTable
        testid="client-returns-table"
        columns={columns}
        searchPlaceholder="Search serial..."
        refreshKey={refresh}
        load={(params) => api.get("/client-returns", { params }).then((r) => r.data)}
        emptyText="No materials pending client acceptance"
        rowActions={(r) => (
          <Button data-testid={`client-accept-btn-${r.id}`} variant="ghost" size="sm" onClick={() => { setActive(r); setRemarks(""); setOpen(true); }}>
            <CheckCircle2 className="mr-1 h-4 w-4 text-emerald-600" /> Accept
          </Button>
        )}
      />
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle className="font-display">Accepted by Client · {active?.material_number}</DialogTitle></DialogHeader>
          <div><Label>Remarks / Reference</Label><Input data-testid="client-accept-remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} className="mt-1" /></div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button data-testid="client-accept-confirm" onClick={accept} className="bg-emerald-600 hover:bg-emerald-700">Confirm Acceptance</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
